import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { Typography } from "@mui/material";

type QATitleProps = React.ComponentProps<"p">;

export const QATitle = ({ children }: QATitleProps) => {
  const componentColors = useSelector(
    (state: RootState) => state.theme.componentColors
  );

  return (
    <Typography
      sx={{
        color: componentColors.surface.onSurfaceDetachable,
        borderBottom: "1px solid",
        borderBottomColor: componentColors.outline.outline,
      }}
      className="text-left text-2xl lg:text-3xl pb-8 lg:pb-0 lg:border-none pt-6"
    >
      {children}
    </Typography>
  );
};
